// extracted by mini-css-extract-plugin
export var scrollArea = "_ny-0";